import { render, staticRenderFns } from "./loadbalancers.vue?vue&type=template&id=03afd989&"
import script from "./loadbalancers.vue?vue&type=script&lang=js&"
export * from "./loadbalancers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports